<template>
  <Dialog
    :modifierClass="$style.root"
    v-on="$listeners"
    v-bind="$props"
    noOkBtn
    noCancelBtn
    textAlign="left"
    :maskClosable="false"
  >
    <input
      v-model="mobileForm.mobile"
      style="margin-top: 23px"
      :class="$style.input"
      type="text"
      placeholder="请输入你的手机号"
      @focus="onFocus"
      @blur="onBlur"
    />
    <div v-if="needCaptcha" :class="$style.captchaContainer" class="u-textLeft">
      <input
        v-model="mobileForm.smscode"
        :class="$style.inputSmall"
        type="text"
        placeholder="验证码"
        @focus="onFocus"
        @blur="onBlur"
      />
      <img :class="$style.captchat" :src="captchaImg" />
      <div :class="$style.refreshBtn" @click="refreshCaptcha"
        ><img :class="$style.iconRefresh" src="./img/icon-refresh.png" />换一个</div
      >
    </div>
    <div :class="$style.inputContainer">
      <input
        v-model="mobileForm.smscode"
        :class="$style.input"
        type="text"
        placeholder="请输入短信验证码"
        @focus="onFocus"
        @blur="onBlur"
      />
      <button v-if="mobileForm.first" :class="$style.sendPhoneCode" @click="sendSmsCode"
        >获取验证码</button
      >
      <span v-else-if="mobileForm.pengding" :class="[$style.smsInputWidget, 'is-pending']"
        >{{ mobileForm.clock }}s</span
      >
      <button v-else :class="[$style.sendPhoneCode, 'is-retry']" @click="sendSmsCode"
        >重新获取</button
      >
    </div>
    <button class="u-marginTop20" :class="$style.confirmBtn" @click="submit">确认</button>
  </Dialog>
</template>

<script>
import fectx from "helper/fectx";
import fectxAlt from "helper/fectxAlt";
import Message from "base-components/Message";
import Dialog from "../DialogWithLogo";

const PHONE_REGEX = /^[1-9][0-9]{10}$/;
const PHONE_SMS_INTERVAL = 60;

const requestSendSmsCode = (mobile, captcha) =>
  fectx.post("/act/sendsms", { mobile, captcha, codeType: "wxgzhbindmobile" });
const requestCaptcha = () => fectxAlt.get("/Captcha");
const requestBindPhone = (mobile, smscode, sourceId, actCode = "") =>
  fectx.post(`/wechat/mobilelogin`, {
    mobile,
    smscode,
    sourceId,
    actCode,
  });

export default {
  name: "BindPhoneDialog",
  props: {
    ...Dialog.props,
    sourceId: {},
    actCode: {},
  },
  components: {
    Dialog,
  },
  data() {
    return {
      needCaptcha: false,
      captchaImg: "",
      mobileForm: {
        mobile: undefined,
        smscode: undefined,
        captcha: "",
        pengding: false,
        clock: PHONE_SMS_INTERVAL,
        first: true,
      },
    };
  },
  methods: {
    async refreshCaptcha() {
      let resp;
      try {
        resp = await requestCaptcha();
      } catch (_error) {
        return;
      }

      const data = resp.data;
      // eslint-disable-next-line eqeqeq
      if (data.ResultCode != "200") {
        return;
      }

      this.captchaImg = "data:image/png;base64," + data.InnerData;
    },
    async sendSmsCode() {
      if (this.mobileForm.pengding) {
        return;
      }

      if (!PHONE_REGEX.test(this.mobileForm.mobile)) {
        Message.error("请输入正确的手机号");
        return;
      }

      // 清空之前的短信验证码
      this.mobileForm.smscode = "";

      const timer = setInterval(() => {
        this.mobileForm.clock -= 1;
        if (this.mobileForm.clock <= 0) {
          clearTimer();
        }
      }, 1000);

      const clearTimer = () => {
        clearInterval(timer);
        this.mobileForm.pengding = false;
      };

      this.mobileForm.pengding = true;
      this.mobileForm.clock = PHONE_SMS_INTERVAL;
      this.mobileForm.first = false;

      let resp;
      try {
        resp = await requestSendSmsCode(this.mobileForm.mobile, this.mobileForm.captcha);
      } catch (error) {
        Message.error("网络错误");
        clearInterval(timer);
        return;
      }
      const data = resp.data;

      // eslint-disable-next-line eqeqeq
      if (data.ResultCode != "200") {
        Message.error(data.InnerData || resp.statusText);
        clearTimer();
        return;
      }

      // eslint-disable-next-line eqeqeq
      if (data.InnerData && data.InnerData.ErrorCode == "10000") {
        clearTimer();
        Message.warn("请先输入图形验证码");
        this.needCaptcha = true;
        this.refreshCaptcha();
        return;
      }
    },
    async bindPhone(mobile, smscode) {
      let resp;
      try {
        resp = await requestBindPhone(mobile, smscode, this.sourceId, this.actCode);
      } catch (error) {
        Message.error("网络错误");
      }

      const data = resp.data;
      // eslint-disable-next-line eqeqeq
      if (data.ResultCode != "200") {
        Message.error(data.InnerData || resp.statusText);
        return;
      }

      const payload = data.InnerData;
      this.$emit("success", payload);
    },
    submit() {
      if (!PHONE_REGEX.test(this.mobileForm.mobile, this.mobileForm.captcha)) {
        Message.warn("请输入正确的手机号");
        return;
      }

      if (!this.mobileForm.smscode) {
        Message.warn("请输入验证码");
        return;
      }

      this.bindPhone(this.mobileForm.mobile, this.mobileForm.smscode);
    },
    onFocus() {
      // mark 键盘顶起页面bug 导致元素点击区域便宜
      const supportPageOffset = window.pageXOffset !== undefined;
      const isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
      this._scrollTop = supportPageOffset
        ? window.pageYOffset
        : isCSS1Compat
        ? document.documentElement.scrollTop
        : document.body.scrollTop;
    },
    onBlur() {
      // mark 键盘顶起页面bug 导致元素点击区域便宜
      window.scroll(0, this._scrollTop);
    },
  },
};
</script>

<style lang="scss" module>
$page-width: 375;
@import "~style/tool";

.root {
  :global {
    .Dialog__box {
      max-height: none;
    }
    
    .Dialog__box {
      width: 310px !important;
    }

    .Dialog__content {
      margin: 0 auto;
      width: 250px;
    }
  }
}

.inputContainer {
  position: relative;
  margin-top: 10px;
}

.input {
  box-shadow: none;
  outline: none;
  width: 250px;
  border-radius: 3px;
  padding: 12px 14px;
  border: 1px solid rgba(153, 153, 153, 1);
  font-size: 14px;
  user-select: text;
}

.input::placeholder {
  color: rgba(153, 153, 153, 1);
}

.captchaContainer {
  position: relative;
  width: 250px;
  margin: 10px auto 0;
  display: flex;
  align-items: center;
}

.inputSmall {
  composes: input;
  width: 108px;
}

.captchat {
  margin-left: 4px;
  width: 72px;
  height: 44px;
}

.refreshBtn {
  margin-left: 10px;
  font-size: 12px;
  font-weight: bold;
  color: rgba(245, 98, 92, 1);
}

.iconRefresh {
  position: relative;
  top: 4px;
  width: 16px;
  height: 16px;
  margin-right: 2px;
}

.smsInputWidget {
  position: absolute;
  right: 9px;
  top: 7px;
  padding: 8px 10px;
  font-size: 12px;
  line-height: 1;
  font-weight: bold;
  background: transparent;
  color: rgba(102, 102, 102, 1);
}

.sendPhoneCode {
  composes: smsInputWidget;

  border: 0;
  color: rgba(255, 255, 255, 1);
  background: rgba(245, 98, 92, 1);
  border-radius: 2px;

  &:global(.is-retry) {
    background: transparent;
    color: #f5625c;
  }
}

.confirmBtn {
  width: 250px;
  border: 0;
  padding: 15px 10px;
  font-size: 19px;
  line-height: 1;
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
  background: linear-gradient(180deg, rgba(255, 119, 119, 1) 0%, rgba(227, 63, 46, 1) 100%);
  border-radius: 4px;
}
</style>
